
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 7 6"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"var(--icon-error)","d":"M3.384 5.861 0 .001h6.768z"}})])
          )
        }
      }
    